<template>
  <QBtn
    color="primary"
    unelevated
    :dense="!isMobile"
    :padding="isMobile ? undefined : '4px 10px 4px 16px'"
    :round="isMobile"
    :rounded="!isMobile"
    :label="isMobile ? undefined : 'New'"
    :disable="!list.length"
    :icon-right="isMobile ? undefined : 'eva-chevron-down'"
    :icon="isMobile ? 'eva-plus-outline' : undefined"
    no-caps
    class="text-weight-medium"
  >
    <QPopupProxy
      maximized
      v-if="isMobile"
      transition-show="slide-up"
      transition-hide="slide-down"
      :breakpoint="10000"
    >
      <div class="bg-white column">
        <QSpace />
        <div class="row">
          <QBtn
            flat
            :color="item.active ? 'primary' : 'grey-8'"
            v-close-popup
            :class="`col-${colWidth}`"
            v-for="item in list"
            :key="item.key"
            padding="sm md"
            no-caps
            @click="$emit(`create`, item.key)"
          >
            <div class="column items-center">
              <QIcon :name="item.icon" size="48px" />
              <span class="text-center text-weight-medium q-pt-sm">
                {{ item.description }}
              </span>
            </div>
          </QBtn>
        </div>
        <slot />
        <div class="row justify-center q-mb-xl">
          <QBtn
            v-close-popup
            flat
            label="Close"
            color="grey-6"
            padding="md"
            :ripple="false"
            no-caps
          />
        </div>
      </div>
    </QPopupProxy>
    <QMenu
      v-else
      color="primary"
      self="top right"
      anchor="bottom right"
      :offset="[0, 8]"
    >
      <QList style="min-width: 160px;">
        <QItem
          v-for="item in list"
          :key="item.key"
          clickable
          :ripple="false"
          v-close-popup
          @click="$emit(`create`, item.key)"
        >
          <QItemSection>
            <span>{{ item.label }}</span>
          </QItemSection>
        </QItem>
      </QList>
      <slot />
    </QMenu>
  </QBtn>
</template>

<script>
import {
  QBtn,
  QMenu,
  ClosePopup,
  QList,
  QItem,
  QItemSection,
  QPopupProxy,
  QIcon,
  QSpace
} from 'quasar';

export default {
  name: 'InLifeCreate',
  props: {
    isMobile: Boolean,
    list: {
      type: Array,
      default: () => []
    },
    minColWidth: {
      type: Number,
      default: 4
    }
  },
  computed: {
    colWidth() {
      const width = Math.floor(12 / this.list.length);
      return width < this.minColWidth ? this.minColWidth : width;
    }
  },
  components: {
    QBtn,
    QMenu,
    QList,
    QItem,
    QItemSection,
    QPopupProxy,
    QIcon,
    QSpace
  },
  directives: {
    ClosePopup
  }
};
</script>
